// варианты цветовых схем
const themes = ['bimlib', 'gisp']

// список компонентов которые будут опубликованы в npm пакет
const components = {
  // form
  bimButton: './src/components/form/bimButton/bimButton.vue',
  bimSelect: './src/components/form/bimSelect/bimSelect.vue',
  bimCheckbox: './src/components/form/bimCheckbox/bimCheckbox.vue',
  bimEditorJS: './src/components/form/bimEditorJS/bimEditorJS.vue',
  bimInput: './src/components/form/bimInput/bimInput.vue',
  bimRadio: './src/components/form/bimRadio/bimRadio.vue',
  bimTextarea: './src/components/form/bimTextarea/bimTextarea.vue',
  bimMultiSelect: './src/components/form/bimMultiSelect/bimMultiSelect.vue',
  bimDatepick: './src/components/form/bimDatepick/bimDatepick.vue',
  bimCalendar: './src/components/form/bimCalendar/bimCalendar.vue',
  bimTumbler: './src/components/form/bimTumbler/bimTumbler.vue',
  bimErrorField: './src/components/form/bimErrorField/bimErrorField.vue',
  bimManufacturerHints: './src/components/form/bimManufacturerHints/bimManufacturerHints.vue',

  // text
  bimText: './src/components/text/bimText/bimText.vue',
  bimTextH1: './src/components/text/bimTextH1/bimTextH1.vue',
  bimTextH2: './src/components/text/bimTextH2/bimTextH2.vue',
  bimTextH3: './src/components/text/bimTextH3/bimTextH3.vue',
  bimTextH4: './src/components/text/bimTextH4/bimTextH4.vue',
  bimTextH5: './src/components/text/bimTextH5/bimTextH5.vue',
  bimTextAccent: './src/components/text/bimTextAccent/bimTextAccent.vue',
  bimTextMain: './src/components/text/bimTextMain/bimTextMain.vue',
  bimTextMedium: './src/components/text/bimTextMedium/bimTextMedium.vue',
  bimTextDesc: './src/components/text/bimTextDesc/bimTextDesc.vue',
  bimTextHint: './src/components/text/bimTextHint/bimTextHint.vue',
  bimTextSmall: './src/components/text/bimTextSmall/bimTextSmall.vue',

  // grid
  bimContainer: './src/components/grid/bimContainer/bimContainer.vue',
  bimRow: './src/components/grid/bimRow/bimRow.vue',
  bimCol: './src/components/grid/bimCol/bimCol.vue',

  // ui
  formPhoneVerification: './src/components/ui/formPhoneVerification/formPhoneVerification.vue',
  bimBreadcrumbs: './src/components/ui/bimBreadcrumbs/bimBreadcrumbs.vue',
  bimPhoneRequest: './src/components/ui/bimPhoneRequest/bimPhoneRequest.vue',
  bimInvitePopup: './src/components/ui/bimInvitePopup/bimInvitePopup.vue',
  bimArticleEdit: './src/components/ui/bimArticleEdit/bimArticleEdit.vue',
  bimTable: './src/components/ui/bimTable/bimTable.vue',
  bimPagination: './src/components/ui/bimPagination/bimPagination.vue',
  bimTooltip: './src/components/ui/bimTooltip/bimTooltip.vue',
  bimPopup: './src/components/ui/bimPopup/bimPopup.vue',
  bimFooter: './src/components/ui/bimFooter/bimFooter.vue',
  bimHeader: './src/components/ui/bimHeader/bimHeader.vue',
  bimProductCard: './src/components/ui/bimProductCard/bimProductCard.vue',
  bimImg: './src/components/ui/bimImg/bimImg.vue',
  bimLeftMenu: './src/components/ui/bimLeftMenu/bimLeftMenu.vue',
  wizardRegForm: './src/components/ui/wizardRegForm/wizardRegForm.vue',
  bimAffProgramm: './src/components/ui/bimAffProgramm/bimAffProgramm.vue',
  bimSteps: './src/components/ui/bimSteps/bimSteps.vue',
  bimNotices: './src/components/ui/bimNotices/bimNotices.vue',
  bimPopover: './src/components/ui/bimPopover/bimPopover.vue',
}

// текущая тема
const currentTheme = () => {
  let theme = process.env.VUE_THEME

  if (theme === undefined || !themes.includes(theme)) {
    theme = themes[0]
  }

  return theme
}

// authHost = (dev, stage, prod)
function authHost (appEnv = 'prod') {
  switch (appEnv) {
    case 'dev':
      return 'https://auth.dev.bimlib.ru'
    case 'stage':
      return 'https://auth.bimlib.pro'
    case 'preprod':
      return 'https://auth.preprod.bimlib.ru'
    case 'prod':
    default:
      return 'https://auth.bimlib.pro'
  }
}

function webApiHost (appEnv = 'prod') {
  switch (appEnv) {
    case 'dev':
      return 'https://api.dev.bim.bimlib.ru'
    case 'stage':
      return 'https://api.dev.bim.bimlib.ru'
    case 'preprod':
      return 'https://api.preprod.bim.bimlib.ru'
    case 'prod':
    default:
      return 'https://api.bim.bimlib.ru'
  }
}

module.exports = {
  themes,
  components,
  currentTheme: currentTheme(),
  authHost,
  webApiHost,
  uploadImagePrefix: '/uploads',
}
